import React from 'react';

import { SortableElement, SortableHandle } from 'react-sortable-hoc';

import {
  Category,
  City,
  Company,
  DateTime,
  Distance
} from './filters';

const DragHandle = SortableHandle(() => {
  return (
    <div className="text-center">
      <div className="btn-xs btn btn-default dragMe">
        Hold here to move
      </div>
    </div>
  );
});

const renderFilter = (filter, styles) => {
  switch (filter.filter_type) {
    case 'category':
      return <Category filter={filter} styles={styles} />;
    case 'city':
      return <City filter={filter} styles={styles} />;
    case 'company':
      return <Company filter={filter} styles={styles} />;
    case 'date':
      return <DateTime filter={filter} styles={styles} />;
    case 'distance':
      return <Distance filter={filter} styles={styles} />;
    default:
      return null;
  }
};

const FilterItem = SortableElement(({ filter, styles }) => {
  const { container } = styles;
  return (
    <li style={container || {}} className={`filter-item ${filter.filter_type}Filter`}>
      <DragHandle />
      {renderFilter(filter, styles)}
    </li>
  );
});

export default FilterItem;
